import React from 'react';
import Truncate from '../common/truncate/Truncate';
export var AgentName = function AgentName(_ref) {
  var salutation = _ref.salutation,
    title = _ref.title,
    name = _ref.name;
  var prefix = "".concat(salutation || '', " ").concat(title || '');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "agent-name",
    className: "font-heading-medium-bold"
  }, prefix.trim().length !== 0 ? /*#__PURE__*/React.createElement(Truncate, {
    "data-testid": "name",
    clamp: 3
  }, prefix, /*#__PURE__*/React.createElement("br", null), name) : /*#__PURE__*/React.createElement(Truncate, {
    "data-testid": "name",
    clamp: 3
  }, name)));
};